import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Bootstrap components
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Custom Styles
import "../scss/pages/educationalOffer.styles.scss";

// Axios
import axios from "axios";

import {
  filterLicenciaturasWithAttributes,
  getLicenciaturaImageUrl,
} from "../utils/licenciaturaImage";
import CourseMedia from "../assets/img/course-media.jpg";

function EducationalOffer() {
  const [educationalOfferData, setEducationalOfferData] = useState([]);
  const [programsData, setProgramsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const [error, setError] = useState({ error: false, message: "" });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/graphql`,
          {
            query: `
            {
              cursoLicenciatura{
                data{
                  attributes{
                    Titulo
                    Parrafo
                    AcercaDeLicenciaturas{
                      Titulo
                      Informacion
                      imagen{
                        data{
                          attributes{
                            url
                          }
                        }
                      }                      
                    }
                    OpcionesAcademicas{
                      Titulo
                      Descripcion
                      imagen{
                        data{
                          attributes{
                            url
                          }
                        }
                      }    
                    }
                  }
                }
              }
            }
          `,
          }
        );
        console.log(response.data.data);
        const attrs = response.data.data?.cursoLicenciatura?.data?.attributes;
        if (attrs) {
          setEducationalOfferData(attrs);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setError({ error: true, message: error.message || error.toString() });
      } finally {
        setLoading(false);
      }
      // console.log(response.data.data);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData2 = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/graphql`,
          {
            query: `
            {
              licenciaturas{
                data{
                  id
                  attributes{
                    Nombre
                    Descripcion
                    ImagenLicenciatura{
                      data{
                        attributes{
                          url
                        }
                      }                        
                    }
                  }
                }
              }
            }
          `,
          }
        );
        setProgramsData(
          filterLicenciaturasWithAttributes(
            response.data.data?.licenciaturas?.data
          )
        );
      } catch (error) {
        console.error("Error fetching data:", error);
        setError({ error: true, message: error.message || error.toString() });
      } finally {
        setLoadingCourses(false);
      }
      // console.log(response.data.data);
    };

    fetchData2();
  }, []);

  if (loading || loadingCourses) {
    return (
      <section className="loading">
        <Container>
          <h6>Cargando información...</h6>
        </Container>
      </section>
    );
  }
  if (error.error) {
    return (
      <section className="loading">
        <Container>
          <h6>No se pudo cargar la información en este momento ⌛️</h6>
        </Container>
      </section>
    );
  }
  return (
    <>
      <section className="jumbotron--informative">
        <h2>Oferta Educativa</h2>
      </section>
      <section className="educational-offer">
        <Container fluid>
          <div className="educational-offer__heading">
            {/* <div className="spacer--red"></div> */}
            {/* <h5>{educationalOfferData.Titulo}</h5> */}
            <p>{educationalOfferData?.Parrafo}</p>
          </div>
          <div className="educational-offer__list">
            {programsData.map((program) => (
              <Link
                key={program.id}
                to={`/oferta-educativa/${program.id}`}
                className="educational-offer__list__item"
              >
                <div className="educational-offer__list__item__media">
                  <img src={getLicenciaturaImageUrl(program)} alt="" />
                </div>
                <div className="educational-offer__list__item__body">
                  <h6>{program.attributes.Nombre}</h6>
                  <p>{program.attributes.Descripcion}</p>
                  <span className="educational-offer__list__item__cta">
                    Más información
                  </span>
                </div>
              </Link>
            ))}

            {/* <div className="educational-offer__list__item">
              <div className="educational-offer__list__item__media">
                <img src={CourseMedia} alt="" />
              </div>
              <div className="educational-offer__list__item__body">
                <h6>Licenciatura en Enseñanza y Aprendizaje del Español</h6>
                <p>
                  Cum sociis natoque penatibus et magnis dis parturient montes,
                  nascetur ridiculus mus. Nulla consequat massa quis enim.
                </p>
                <Link to={`/oferta-educativa/3`}>Más información</Link>
              </div>
            </div>
            <div className="educational-offer__list__item">
              <div className="educational-offer__list__item__media">
                <img src={CourseMedia} alt="" />
              </div>
              <div className="educational-offer__list__item__body">
                <h6>Licenciatura en Enseñanza y Aprendizaje del Español</h6>
                <p>
                  Cum sociis natoque penatibus et magnis dis parturient montes,
                  nascetur ridiculus mus. Nulla consequat massa quis enim.
                </p>
                <Link to={`/oferta-educativa/3`}>Más información</Link>
              </div>
            </div>
            <div className="educational-offer__list__item">
              <div className="educational-offer__list__item__media">
                <img src={CourseMedia} alt="" />
              </div>
              <div className="educational-offer__list__item__body">
                <h6>Licenciatura en Enseñanza y Aprendizaje del Español</h6>
                <p>
                  Cum sociis natoque penatibus et magnis dis parturient montes,
                  nascetur ridiculus mus. Nulla consequat massa quis enim.
                </p>
                <Link to="/curso-individual">Más información</Link>
              </div>
            </div>
            <div className="educational-offer__list__item">
              <div className="educational-offer__list__item__media">
                <img src={CourseMedia} alt="" />
              </div>
              <div className="educational-offer__list__item__body">
                <h6>Licenciatura en Enseñanza y Aprendizaje del Español</h6>
                <p>
                  Cum sociis natoque penatibus et magnis dis parturient montes,
                  nascetur ridiculus mus. Nulla consequat massa quis enim.
                </p>
                <Link to="/curso-individual">Más información</Link>
              </div>
            </div> */}
          </div>
        </Container>
      </section>
      {/* <section className="educational-offer__about">
        <Container fluid>
          <Row>
            <Col xs="12" lg="6" className="educational-offer__about__content">
              <h4>{educationalOfferData.AcercaDeLicenciaturas?.Titulo}</h4>
              {(educationalOfferData.AcercaDeLicenciaturas?.Informacion ?? "")
                .split("\n\n")
                .filter(Boolean)
                .map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
            </Col>
            <Col xs="12" lg="6" className="educational-offer__about__media">
              <img
                src={
                  educationalOfferData.AcercaDeLicenciaturas?.imagen?.data
                    ?.attributes?.url ?? CourseMedia
                }
                className="img-fluid"
                alt=""
              />
            </Col>
          </Row>
        </Container>
      </section> */}
      {/* <section className="educational-offer__all-courses">
        <div className="educational-offer__all-courses__heading">
          <div className="spacer--red"></div>
          <h5>Nuestras opciones académicas</h5>
        </div>
        <div className="educational-offer__all-courses__list">
          {(educationalOfferData.OpcionesAcademicas ?? []).map((item, key) => {
            const imageUrl =
              item?.imagen?.data?.attributes?.url ?? CourseMedia;
            return (
              <div
                className="educational-offer__all-courses__list__item"
                style={{
                  backgroundImage: `linear-gradient(
                    180deg,
                    rgba(0, 70, 125, 0.22) 0%,
                    #00467d 100%
                  ), url(${imageUrl})`,
                }}
                key={key}
              >
                <h6>{item.Titulo}</h6>
                <p>{item.Descripcion}</p>
              </div>
            );
          })}

        </div>
      </section> */}
    </>
  );
}

export default EducationalOffer;
